var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#90CAF9",
    d: "M40 45L8 45 8 3 30 3 40 13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1F5FE",
    d: "M38.5 14L29 14 29 4.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    d: "M21 23L14 33 28 33z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976D2",
    d: "M28 26.4L23 33 33 33zM31.5 23A1.5 1.5 0 1 0 31.5 26 1.5 1.5 0 1 0 31.5 23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.7a536e62f4b6a2f4cd2e2cd988b292c6.svg";
export { ForwardRef as ReactComponent };